import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface CampaignCloseToServingLimitProps extends BaseTemplateProps {
  campaignName: string
  campaignLink: string
  thresholdPercent: number
  campaignBudget: string
  averageDailySpend: string
  daysRemaining: number
}

export const CampaignCloseToServingLimit: TemplateDefinition<CampaignCloseToServingLimitProps> = {
  renderParams: (props: CampaignCloseToServingLimitProps) => ({
    messageKey: 'notificationsDomain.templates.campaignCloseToServingLimit',
    values: {
      campaignName: props.campaignName,
      campaignLink: props.campaignLink,
      thresholdPercent: props.thresholdPercent,
      campaignBudget: props.campaignBudget,
      averageDailySpend: props.averageDailySpend,
      daysRemaining: props.daysRemaining,
    },
  }),
  getLink: (props: CampaignCloseToServingLimitProps): string => props.campaignLink,
}
